import React, { ReactNode } from "react";
import { style, classes } from "typestyle";
import { hSpaced } from "../../../../cssUtils";

interface GridProps {
  left: ReactNode;
  right: ReactNode;
  center?: ReactNode;
}

const Grid = ({ left, right, center }: GridProps) => (
  <div
    className={classes(
      style(hSpaced(6)),
      style({
        display: "flex",
        alignItems: "center",
        $nest: {
          "&>*": {
            width: "100%",
          },
        },
      }),
    )}
  >
    {left}
    <div
      className={style({
        display: "flex",
        alignItems: "center",
        minWidth: "24px",
        maxWidth: "24px",
      })}
    >
      {center}
    </div>
    {right}
  </div>
);

export default Grid;
